import * as $ from 'jquery';
import 'bootstrap';
import 'selectize';
import 'simplePagination';
import 'slick';
import { bookingFormCommon } from "../c005-bookingform-common";
import * as numeral from 'numeral';
import * as moment from 'moment';

export class enrichSpendBenefits {
	private catelogueForm: any = $('.member-enrich-spendbenefits');
	private bookingformcommon = new bookingFormCommon();
	private banId: any;
	appendCategories(): void {
		let _self = this;
		var catelogueList = $.Deferred();
		let authenticationUrl: string = '';

		if (window.location.hostname === 'localhost' && window.location.port == "5000") {
			authenticationUrl = '/dummy-data/spendBenefits.json';
		}
		else {
			authenticationUrl = '/bin/services/new/getSpendBenefitsData';
		}
		$.get(authenticationUrl)
			.done((data: any) => {
				if (typeof data === 'string') {
					data = JSON.parse(data);
				}
				var today = moment(new Date()).format('DD/MM/YYYY');
				$('#today_date').append(today);
				var keyList = Object.keys(data);
				function bindDataToTable(d: any, obj: any) {
					var keysssd = Object.keys(d);
					const benefitsTableKeys = [];
					var k, i, len;

					for (k in data) {
						if (data.hasOwnProperty(k)) {
							benefitsTableKeys.push(k);
						}
					}
					benefitsTableKeys.sort(function (a, b) {
						return parseInt(a) - parseInt(b);
					});
					len = benefitsTableKeys.length;
					var table = document.createElement("table");
					var trHead = document.createElement("tr");
					$(benefitsTableKeys).each((index: any, item: any) => {
						if (item == 'Enrich Basic Points') {
							data[item].forEach((spendItem: any, i: any) => {
								var th = document.createElement("th");
								var span = th.appendChild(document.createElement("SPAN"));
								span.setAttribute("class", "benefitsTableHead" + index);
								span.innerHTML = spendItem.tresholdDisplay;
								trHead.appendChild(th)
								$(th).css("border", "2px solid");
							});
						}
					})
					$(benefitsTableKeys).each((index: any, item: any) => {
						if ((item !== 'enrichBasePoints') && (item !== 'Enrich Basic Points')) {
							data[item].forEach((spendItem: any, i: any) => {
								var th = document.createElement("th");
								th.innerHTML = spendItem.tresholdDisplay;
								trHead.appendChild(th)
								$(th).css("border", "2px solid");
							});
						}
					})
					table.appendChild(trHead)
					$(obj).append(table);
					var tr = document.createElement("tr");
					$(benefitsTableKeys).each((index: any, item: any) => {
						if (item !== 'enrichBasePoints') {
							data[item].forEach((spendItem: any, i: any) => {
								const spendBenefitsData = spendItem.tresholdValue;
								if (spendBenefitsData == 'Accumulated Points Earning') {
									var td = document.createElement("td");
									td.setAttribute("class", "benefitsTable" + i);
									var span = td.appendChild(document.createElement("SPAN"));
									span.setAttribute("class", "benefitsRow" + i);
									span.innerHTML = spendItem.benefits;
									td.appendChild(span);
									tr.appendChild(td);
									$(td).css("border", "2px solid white");
								}
							})
						}
					})
					table.appendChild(tr);
					$(benefitsTableKeys).each((index: any, item: any) => {
						const basePointsProgress = data[item];
						if (item !== 'enrichBasePoints') {
							data[item].forEach((spendItem: any, i: any) => {
								const spendBenefitsData = spendItem.tresholdValue;
								if (spendBenefitsData !== 'Accumulated Points Earning') {
									var td = document.createElement("td");
									td.setAttribute("class", "benefitsTable" + i);
									var span = td.appendChild(document.createElement("SPAN"));
									span.setAttribute("class", "benefitsRow" + i);
									span.innerHTML = spendItem.benefits;
									td.appendChild(span);
									tr.appendChild(td);
									$(td).css("border", "2px solid white");
								} table.appendChild(tr)
							})
						} else if (item == 'enrichBasePoints') {
							$('#enrich--base-pointsprogress').attr("disabled", "disabled");
							$("#enrich--base-pointsprogress").attr("value", basePointsProgress);
						}
					})
					var tr = document.createElement("tr");
					tr.setAttribute("class", "buttonLock");
					$(benefitsTableKeys).each((index: any, item: any) => {
						if (item !== 'enrichBasePoints') {
							data[item].forEach((spendItem: any, i: any) => {
								const spendBenefitsData = spendItem.tresholdValue;
								if (spendBenefitsData == 'Accumulated Points Earning') {
									var td = document.createElement("td");
									td.setAttribute("class", "table" + index);
									var span = td.appendChild(document.createElement("SPAN"));
									span.setAttribute("class", "span" + index);
									$(span).css("border", "2px solid white");
									span.innerHTML = spendItem.lockVal;
									td.appendChild(span);
									tr.appendChild(td);
									$(span).css("border", "none");
								}
								table.appendChild(tr)
							})
						}
					});
					$(benefitsTableKeys).each((index: any, item: any) => {
						if (item !== 'enrichBasePoints') {
							data[item].forEach((spendItem: any, i: any) => {
								const spendBenefitsData = spendItem.tresholdValue;
								if (spendBenefitsData !== 'Accumulated Points Earning') {
									var td = document.createElement("td");
									td.setAttribute("class", "table" + index);
									var span = td.appendChild(document.createElement("SPAN"));
									span.setAttribute("class", "span" + index);
									span.innerHTML = spendItem.lockVal;
									$(span).css("background-color", "#898989");
									$(span).css("border-radius", "6px");
									$(span).css("padding", "6px 18px 7px 18px");
									$(span).css("color", "white");
									td.appendChild(span);
									tr.appendChild(td);
									$(td).css("border", "2px solid white");
								}
								table.appendChild(tr)
							})
						}
					});
					$(obj).append(table);
				}
				bindDataToTable(data, "#data");
			})
			.fail((error: any) => {
				catelogueList.reject(error)
			});
	}
}
let scope: Element = document.querySelector('#member-enrich-spendbenefits');
declare const window: any;
if (scope) {
	try {
		let enrichspendbenefits = new enrichSpendBenefits();
		enrichspendbenefits.appendCategories();
	} catch (e) { console.error(e); }
}